var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"load_source"},_vm._l((_vm.loads),function(item,index){return _c('div',{key:index,ref:item.Refs,refInFor:true,class:item.Class,attrs:{"v-model":item.boolen_val},on:{"click":function($event){return _vm.click_load(item.Class, index, item.cont)}}},[_vm._v("\r\n      "+_vm._s(item.cont)+"\r\n    ")])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8a2bce5a","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/cutline/load_source.vue
// module id = null
// module chunks = 